import React from 'react';
import Modal from '../ui/Modal';
import { Button } from '../ui/button';
import { AlertTriangle } from 'lucide-react';
import { ClientContact, VendorContact } from '../../types';

interface DeleteContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  contact: ClientContact | VendorContact | null;
  contactType: 'client' | 'vendor';
  onConfirm: () => void;
  isLoading: boolean;
}

export const DeleteContactModal: React.FC<DeleteContactModalProps> = ({
  isOpen,
  onClose,
  contact,
  contactType,
  onConfirm,
  isLoading
}) => {
  if (!contact) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Contact"
      size="sm"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-6 w-6 text-red-500" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-medium text-gray-900">
              Are you sure you want to delete this contact?
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-600">
                This will permanently delete <strong>{contact.fullName}</strong> from the {contactType === 'client' ? 'client' : 'vendor'} contacts.
              </p>
              {contact.isPrimary && (
                <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                  <p className="text-sm text-yellow-800">
                    <strong>Warning:</strong> This is the primary contact. You may want to set another contact as primary first.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Deleting...' : 'Delete Contact'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
